import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, token, loading } = useAuth();

  if (loading) return null;
  if (!token) return <Navigate to="/login" replace />;

  if (requiredRole) {
    const allowed = requiredRole === 'admin'
      ? user?.role === 'admin'
      : requiredRole === 'operator'
        ? ['operator', 'admin'].includes(user?.role)
        : true;
    if (!allowed) return <Navigate to="/chat" replace />;
  }

  return children;
}
